export function getSubjectFromPath(eventPath?: string): string | undefined {
  return eventPath ? eventPath.substring(eventPath.lastIndexOf('/') + 1, eventPath.length) : undefined;
}
